module.exports = __webpack_public_path__ + "img/heals_color.add3f509.png";